import React from "react";
import {
    Tooltip,
    Typography,
} from "@material-ui/core";

const Counter = ({ value, label }) => {

    if (!value) return null;

    return (
        <Tooltip title={label || value}>
            <div
                style={{
                    backgroundColor: "var(--mainText)",
                    borderRadius: "50%",
                    height: 24,
                    width: 24,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                }}
            >
                <Typography style={{ color: "var(--negativeText)", fontSize: 12, fontWeight: 500 }}>
                    {value > 9 ? "+9" : value}
                </Typography>
            </div>
        </Tooltip>
    );
}

export default Counter;